import { ResourceLanguage } from 'i18next'

import { en } from './en'
import { kh } from './kh'

export const locales = {
  en: en as unknown as ResourceLanguage,
  kh: kh as unknown as ResourceLanguage,
}
